import React, {useEffect, useState} from 'react'
import ChatComponent from "../../general/ChatComponent";
import {Button} from "primereact/button";
import {Fieldset} from "primereact/fieldset";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";

export default function ScoringChatComponent({showChat, onShowChat, chatMessages, gameid, userid, isMobileDevice, onError}) {

    let [messageCount, setMessageCount] = useState(0);

    useEffect(() => {
        if( chatMessages !== undefined && messageCount < chatMessages.length) {
            onShowChat(true);
            setMessageCount(chatMessages.length);
        }
    }, [chatMessages]);

    if( isMobileDevice ) {
        return <DHDefaultDrawer onClose={() => onShowChat(false)} show={showChat} title="Chat" children={<>
            <ChatComponent messages={chatMessages} type="game" id={gameid} userId={userid}
                           callBackOnError={(message) => onError(message)}/>
        </>}/>
    }
    return <div className="grid align-content-end vertical-container" style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        height: "100%",
        width: 20,
        zIndex: 550,
        margin: 0,
        padding: 0
    }}>
        <div className="col" style={{padding: 0, margin: 0, textAlign: "right"}}>
            <Button className={showChat ? "" : "p-button-secondary"} icon="pi pi-book"
                    style={{height: 35, width: 35, margin: 0, padding: 0, marginTop: 10}} onClick={() => {
                onShowChat(!showChat);
            }} tooltip=""/>
        </div>
        <DHDefaultDrawer onClose={() => onShowChat(false)} show={showChat} title="Chat" children={<div style={{padding:10}}>
            <Fieldset legend="Hilfe zum Chatbereich" toggleable={true} collapsed={true}>
                <div>
                    Du kannst den Chatbereich frei auf dem Fenster plazieren. Dafür im Kopfbereich des Chatbereichs einfach klicken und den Bereich an die gewünschte Position schieben.
                </div>
                <div style={{marginBottom:20}}>
                    Die Größe des Bereichs kann verändert werden, hierzu bitte die Ecke des Bereichs unten rechts nehmen und größer oder kleiner ziehen!!!
                </div>
            </Fieldset>
            <ChatComponent messages={chatMessages} type="game" id={gameid} userId={userid}
                           callBackOnError={(message) => onError(message)}/>
        </div>}/>
    </div>

}


